export default {
  install(Vue, options) {
    //验证当前用户是否有操作权限
    Vue.prototype.hasPermission = function(val){
        var permissions = JSON.parse(localStorage.getItem("CURRENTUSER")).permissions;
        if (permissions != null) {
          var index = permissions.indexOf(val);
          if(index == -1){
            return false;
          }else{
            return true;
          }
        } else {
          return false;
        }
    };
    //table日期格式化
    Vue.prototype.tableDateFormat = function (row, column) {
      var rowDate = row[column.property];
      if (rowDate == null || rowDate == "") {
        return '';
      } else {
        var date = new Date(rowDate);
        if (date == undefined) {
          return rowDate;
        }
        var month = '' + (date.getMonth() + 1),
          day = '' + date.getDate(),
          year = date.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        var newDate = [year, month, day].join('-');
        return newDate;
      }
    }

    //table日期格式化-年月日时分秒
    Vue.prototype.tableDateFormat2 = function (row, column) {
      var rowDate = row[column.property];
      if (rowDate == null || rowDate == "") {
        return '';
      } else {
        var date = new Date(rowDate);
        if (date == undefined) {
          return rowDate;
        }
        var month = '' + (date.getMonth() + 1),
          day = '' + date.getDate(),
          year = date.getFullYear(),
          hour = '' + date.getHours(),
          minute = '' + date.getMinutes(),
          second = '' + date.getSeconds();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        if (hour.length < 2) hour = '0' + hour;
        if (minute.length < 2) minute = '0' + minute;
        if (second.length < 2) second = '0' + second;

        var newDate = [year, month, day].join('-');
        var newTime = [hour, minute, second].join(':');
        return newDate + ' ' + newTime;
      }
    }

    //table中NULL值格式化
    Vue.prototype.tableNullFormat = function (row, column) {
    var rowDate = row[column.property];
      if (rowDate == null || rowDate == "") {
        return '';
      } else {
        return rowDate;
      }
    }

    //table中性别格式化
    Vue.prototype.tableSexFormat = function(row, column) {
      switch (row[column.property]) {
        case "1":
          return "男";
          break;
        case "2":
          return "女";
          break;
        default:
          return "";
      }
    },

    //table每4位加一个空格格式化
    Vue.prototype.tableLongNumFormat =  function (row, column) {
      var rowNum = row[column.property];
      if (rowNum == null || rowNum == "") {
        return '';
      } else {
        return rowNum.replace(/(.{4})/g,'$1 ');
      }
    }

    //table百分数格式化
    Vue.prototype.tablePercentFormat = function (row, column) {
      var rowNum = row[column.property];
      if (rowNum == null || rowNum == "" || rowNum == "-1") {
        return '-';
      } else {
        return Math.round(rowNum*100*100)/100 + "%";
      }
    }

    //table的行样式
    Vue.prototype.rowStyle = function() {
      return {height: '40px'};
    }

    //日期格式化
    Vue.prototype.dateFormat = function(val){
      var date = new Date(val);
      if (date == undefined) {
        return val;
      }
      var month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      var newDate = [year, month, day].join('-');
      return newDate;
    }

    //字符串每4位加一个空格
    Vue.prototype.longNumFormat = function(val){
      if(val == null){
          return null;
      }else{
          return val.replace(/(.{4})/g,'$1 ');
      }
    }
    //剩余多少个字
    Vue.prototype.checkWord = function(text, name, maxlength) {
      if (text != "" && text != null && text != undefined) {
        var length = text.length;
        var curr = maxlength - length;
        var ele = document.getElementById(name);
        if (ele != null) {
          document.getElementById(name).innerHTML = curr.toString();
        }
      }
    }

       //判断属性值是否相等
    Vue.prototype.checkAttrValue  = function(val,value) {
//  	console.log(val+"==="+value)
    	if(val==value){
    		return true;
    	}
      return false;
    }

    //获取当前客户端IP
    Vue.prototype.getIp = function() {
      return returnCitySN["cip"];
    }
    //下载文件系统文件
    Vue.prototype.download = function(data,filename) {
      if (!data&&!filename) {
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    }
    //获取当前时间 年月日
    Vue.prototype.getDate = function (){
      var now = new Date();

      var year = now.getFullYear();      　　 //年
      var month  = now.getMonth() + 1;     //月
      if(month<9){
        month ='0'+month
      }
      var day = now.getDate();            　　//日
      if(day<9){
        day ='0'+day
      }
      return year+'年'+month +'月'+day+'日'
    }

    //动态更改数据状态SJZT样式 by li.xue 2020/6/2
    Vue.prototype.sjztStyle = function (val){
      var style;
      if(val == '02' || val == '04' || val == '05'){
        style = "color: #F56C6C;";
      }else if(val == '03'){
        style = "color: #E6A23C;";
      }else if(val == '08'){
        style = "color: #67C23A;";
      }else if(val == '10'){
        style = "color: #B5C334;";
      }else{
        style = "color: #909399;";
      }
      return "font-weight: bold; " + style;
    }

    //动态更改数据状态HYZT样式 by li.xue 2020/6/6
    Vue.prototype.hyztStyle = function (val){
      var style;
      if(val == '1'){
        style = "color: #F56C6C;";
      }else if(val == '2'){
        style = "color: #67C23A;";
      }else if(val == '3'){
        style = "color: #E6A23C;";
      }else{
        style = "color: #909399;";
      }
      return "font-weight: bold; " + style;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/utils.js